import { Router } from '@vaadin/router';
const blue = document.getElementById('blue');
export const router = new Router(blue);
const cmsRoutes = [
    {
        path: 'cms',
        component: 'cms-view',
        action: async () => {
            await import('../routed/cms.js');
        },
    },
    {
        path: 'cms/:type',
        component: 'content-listing',
        action: async () => {
            await import('../routed/cms/listing.js');
        },
    },
    {
        path: 'cms/:type/create',
        component: 'content-create',
        action: async () => {
            await import('../routed/cms/create.js');
        },
    },
    {
        path: 'cms/:type/edit/:guid',
        component: 'content-edit',
        action: async () => {
            await import('../routed/cms/edit.js');
        },
    },
    {
        path: 'cms/:type/version/:guid',
        component: 'content-version',
        action: async () => {
            await import('../routed/cms/version.js');
        },
    },
];
export const views = [
    {
        path: '',
        component: 'dashboard-view',
        title: 'Dashboard',
        action: async () => {
            await import('../routed/dashboard.js');
        },
    },
    {
        path: 'dashboard',
        component: 'dashboard-view',
        title: 'Dashboard',
        action: async () => {
            await import('../routed/dashboard.js');
        },
    },
    {
        path: 'questions',
        component: 'questions-list',
        title: 'Questions List',
        action: async () => {
            await import('../routed/qna/questions.js');
        },
    },
    {
        path: 'question/:questionId',
        component: 'question-edit',
        title: 'Question Edit',
        action: async () => {
            await import('../routed/qna/question.js');
        },
    },
    {
        path: 'question-editor/:questionId',
        component: 'new-question-editor',
        title: 'Question Edit',
        action: async () => {
            await import('../routed/qna/newQuestionEditor.js');
        },
    },
    {
        path: 'questions/create',
        component: 'create-question',
        title: 'Create Question',
        action: async () => {
            await import('../routed/qna/createQuestion.js');
        },
    },
    {
        path: 'financial-portrait',
        component: 'financial-portrait',
        title: 'Financial Portrait',
        action: async () => {
            await import('../routed/financialPortrait/financialPortrait.js');
        },
    },
    {
        path: 'financial-portrait/:guardId',
        component: 'financial-portrait-guard',
        title: 'Financial Portrait',
        action: async () => {
            await import('../routed/financialPortrait/financialPortraitGuard.js');
        },
    },
    {
        path: 'users/:userId',
        component: 'user-summary',
        title: 'User',
        action: async () => {
            await import('../routed/user/summary.js');
        },
    },
    {
        path: 'users',
        component: 'users-view',
        title: 'User Administration',
        action: async () => {
            await import('../routed/users.js');
        },
    },
    {
        path: 'fulfillments',
        component: 'fulfillments-view',
        title: 'Fulfillments',
        action: async () => {
            await import('../routed/fulfillments.js');
        },
    },
    {
        path: 'upcoming-sessions',
        component: 'upcoming-sessions-view',
        title: 'Upcoming Registrations',
        action: async () => {
            await import('../routed/upcomingSessions.js');
        },
    },
    {
        path: 'life-events',
        component: 'life-events-view',
        title: 'Life Events',
        action: async () => {
            await import('../routed/lifeEvents.js');
        },
    },
    {
        path: 'library',
        component: 'library-view',
        title: 'Library',
        action: async () => {
            await import('../routed/library.js');
        },
    },
    {
        path: 'knowledge',
        component: 'knowledge-view',
        title: 'Knowledge',
        action: async () => {
            await import('../routed/knowledge.js');
        },
    },
    {
        path: 'case/:caseId',
        component: 'fulfillment-summary',
        action: async () => {
            await import('../routed/fulfillment/summary.js');
        },
    },
    {
        path: 'life-events/:event',
        component: 'life-event',
        action: async () => {
            await import('../routed/lifeEvents/lifeEvent.js');
        },
    },
    {
        path: 'hubs',
        component: 'hub-listing',
        title: 'Hub Listing',
        action: async () => {
            await import('../routed/benefits/hubs.js');
        },
    },
    {
        path: 'hubs/benefits/:id',
        component: 'hub-edit',
        title: 'Hub Benefits Editor',
        action: async () => {
            await import('../routed/benefits/hubEdit.js');
        },
    },
    {
        path: 'global',
        component: 'global-hub-view',
        title: 'Global Hub',
        action: async () => {
            await import('../routed/global/globalHubView.js');
        },
    },
    {
        path: 'global/:hubSlug',
        component: 'global-hub-view',
        title: 'Global Hub',
        action: async () => {
            await import('../routed/global/globalHubView.js');
        },
    },
    {
        path: 'global/:hubSlug/user/:userId',
        component: 'user-profile',
        title: 'Global User Profile',
        action: async () => {
            await import('../routed/global/userProfile/userProfile.js');
        },
    },
    {
        path: 'global/:hubSlug/user/:userId/case/:caseId',
        component: 'case-summary',
        title: 'Global Case Summary',
        action: async () => {
            await import('../routed/global/case/case.js');
        },
    },
    {
        path: 'global/:hubSlug/user/:userId/case/',
        component: 'case-summary',
        title: 'Global New Case',
        action: async () => {
            await import('../routed/global/case/case.js');
        },
    },
    {
        path: 'global/:hubSlug/user/:userId/case/:caseId/fulfillment',
        component: 'fulfillment-global',
        title: 'Global User Fulfillment',
        action: async () => {
            await import('../routed/fulfillment/globalSummary.js');
        },
    },
    {
        path: 'link-checker',
        component: 'link-checker',
        title: 'Link Checker',
        action: async () => {
            await import('../routed/linkChecker/linkChecker.js');
        },
    },
    {
        path: '(.*)',
        component: 'not-found',
        action: async () => {
            await import('../routed/notFound.js');
        },
    },
];
export const buildRoutes = (grants) => {
    const dynamicViews = [...views];
    if (grants === null || grants === void 0 ? void 0 : grants.cms) {
        const cmsGuardedRoutes = cmsRoutes.map(route => {
            var _a;
            if (!((_a = route.path) === null || _a === void 0 ? void 0 : _a.includes(':type')))
                return route;
            return {
                ...route,
                action: async (context, commands) => {
                    var _a, _b;
                    const contentType = context.params.type;
                    if (!((_a = grants.cms) === null || _a === void 0 ? void 0 : _a.routes.includes(contentType))) {
                        return commands.redirect('/');
                    }
                    return (_b = route.action) === null || _b === void 0 ? void 0 : _b.call(route, context, commands);
                },
            };
        });
        if (['admin', 'editor', 'user'].includes(grants.cms.role)) {
            cmsGuardedRoutes.push({
                path: 'cms/articles/approval',
                component: 'approval-listing',
                action: async () => {
                    await import('../routed/cms/approval-listing.js');
                },
            });
        }
        if (['admin', 'editor'].includes(grants.cms.role)) {
            cmsGuardedRoutes.push({
                path: 'cms/:type/approval/:guid',
                component: 'content-approval',
                action: async () => {
                    await import('../routed/cms/approval.js');
                },
            });
        }
        const catchAllIndex = dynamicViews.findIndex(r => r.path === '(.*)');
        dynamicViews.splice(catchAllIndex, 0, ...cmsGuardedRoutes);
    }
    return [{ path: '', component: 'main-layout', children: dynamicViews }];
};
export const routes = buildRoutes();
export const unauthenticatedRoutes = [
    {
        path: '(.*)',
        component: 'blue-login',
        action: async () => {
            await import('../routed/login.js');
        },
    },
];
//# sourceMappingURL=router.js.map